@if (showPinFields) {
  <div class="flex flex-column gap-3 pt-2" [formGroup]="form">
    @if (selectedPinDeliveryMethod) {
      <div class="otp-sent-description text-sm text-color-secondary border-round p-3">
        @if (selectedPinDeliveryMethod !== 'email') {
          {{ languageService.getTranslation('TEXT_SENT_TO_NUMBER_PREFIX') }}
          <strong>{{ selectedPinDeliveryMethod?.slice(-4) }}</strong>.
        } @else {
          {{ languageService.getTranslation('EMAIL_SENT_TO_PREFIX') }}
          <strong>{{ maskEmail(pinDeliveryOptions.email) }}</strong>
        }
      </div>
    }
    <div class="flex flex-column text-left w-full">
      <label htmlFor="oneTimePin" class="form-label required">
        <app-translate key="ONE_TIME_PIN_FIELD"></app-translate>
      </label>
      <input type="text" id="oneTimePin" placeholder="Enter 6-digit code" pInputText
        (keypress)="onlyNumbers($event)" formControlName="oneTimePin" class="mb-1 skinny w-full" />
      <sp-control-error [parameters]="['PIN']"
        [messagesParameters]="[{key: 'required', message: 'PIN is required'}, {key: 'pattern', message: 'Enter a valid 6-digit PIN number.'}]"
      [control]="form.controls['oneTimePin']"></sp-control-error>
    </div>
    @if (step3ErrorType === 'invalid') {
      <app-error-banner
        [title]="languageService.getTranslation('PIN_INVALID_TITLE')"
      [message]="languageService.getTranslation('PIN_INVALID_MESSAGE')"></app-error-banner>
    }
    <div>
      <p-button [styleClass]="'button-secondary'"
        [label]="languageService.getTranslation('VERIFY_PIN')" (click)="verifyPinClicked()"
      [disabled]="locked || !form.get('oneTimePin')?.value" [outlined]="true"></p-button>
    </div>
  </div>
}